(() => {
  const root = document.documentElement;
  const announcement = document.querySelector('[data-announcement-bar]');
  const updateAnnouncementHeight = () => root.style.setProperty('--announcement-height', `${announcement ? announcement.offsetHeight : 0}px`);
  updateAnnouncementHeight();
  window.addEventListener('resize', updateAnnouncementHeight, { passive: true });

  const searchDialog = document.querySelector('[data-header-search]');
  const closeSearch = () => {
    if (!searchDialog) return;
    searchDialog.classList.remove('is-open');
    document.body.classList.remove('search-open');
  };

  document.querySelectorAll('[data-search-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!searchDialog) return;
      searchDialog.classList.add('is-open');
      document.body.classList.add('search-open');
      searchDialog.querySelector('input')?.focus();
    });
  });
  document.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', closeSearch));
  searchDialog?.addEventListener('click', (event) => { if (event.target === searchDialog) closeSearch(); });


  const mobileMenuPanel = document.querySelector('[data-mobile-menu-panel]');
  const mobileMenuOverlay = document.querySelector('[data-mobile-menu-overlay]');
  const mobileMenuOpenButtons = document.querySelectorAll('[data-mobile-menu-open]');
  const mobileMenuCloseButtons = document.querySelectorAll('[data-mobile-menu-close]');

  const openMobileMenu = (button) => {
    if (!mobileMenuPanel) return;

    mobileMenuOpenButtons.forEach((item) => item.setAttribute('aria-expanded', 'true'));
    mobileMenuPanel.setAttribute('aria-hidden', 'false');
    mobileMenuOverlay?.removeAttribute('hidden');

    requestAnimationFrame(() => {
      mobileMenuPanel.classList.add('is-open');
      mobileMenuOverlay?.classList.add('is-open');
    });

    document.body.classList.add('menu-open');
    setTimeout(() => mobileMenuPanel.querySelector('[data-mobile-menu-close]')?.focus(), 50);
  };

  const closeMobileMenus = () => {
    mobileMenuOpenButtons.forEach((item) => item.setAttribute('aria-expanded', 'false'));
    mobileMenuPanel?.classList.remove('is-open');
    mobileMenuPanel?.setAttribute('aria-hidden', 'true');
    mobileMenuOverlay?.classList.remove('is-open');
    document.body.classList.remove('menu-open');

    window.setTimeout(() => {
      if (mobileMenuOverlay && !mobileMenuOverlay.classList.contains('is-open')) {
        mobileMenuOverlay.setAttribute('hidden', '');
      }
    }, 280);
  };

  mobileMenuOpenButtons.forEach((button) => {
    button.addEventListener('click', () => openMobileMenu(button));
  });

  mobileMenuCloseButtons.forEach((button) => {
    button.addEventListener('click', closeMobileMenus);
  });

  mobileMenuOverlay?.addEventListener('click', closeMobileMenus);
  mobileMenuPanel?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMobileMenus);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 990) closeMobileMenus();
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeSearch();
    closeMobileMenus();
  });

  document.querySelectorAll('[data-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
    const filters = document.querySelector('[data-filters]');
    filters?.classList.toggle('is-open');
    button.setAttribute('aria-expanded', filters?.classList.contains('is-open') ? 'true' : 'false');
  }));

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((rootEl) => {
    const select = rootEl.querySelector('[data-variant-select]');
    const price = rootEl.querySelector('[data-product-price]');
    const compare = rootEl.querySelector('[data-product-compare]');
    const button = rootEl.querySelector('[data-add-button]');
    const buttonText = rootEl.querySelector('[data-add-button-text]');
    if (!select) return;
    const variants = JSON.parse(rootEl.querySelector('[data-product-json]')?.textContent || '[]');
    const moneyFormat = rootEl.dataset.moneyFormat || '${{amount}}';
    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount(?:_with_comma_separator)?\s*\}\}/, amount);
    };
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      const media = rootEl.querySelector(`[data-media-id="${variant.featured_media?.id || ''}"]`);
      media?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  });
})();
